import { render, staticRenderFns } from "./GameDashboard.vue?vue&type=template&id=4bd0b740&"
import script from "./GameDashboard.vue?vue&type=script&lang=js&"
export * from "./GameDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GameDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports